import { useEffect } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import PersonalInfo from '~/components/Terms/PersonalInfo/PersonalInfo';
import PrivacyPolicy from '~/components/Terms/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from '~/components/Terms/TermsOfService/TermsOfService';
import { Icon } from '~/components/atomic';
import { disableScrollLock, enableScrollLock } from '~/utils';
import { TermsType } from '../Agreement/Agreement';

interface TermsModalLayoutProps {
  type: TermsType;
  isOpen: boolean;
  setIsOpen: (state: boolean) => void;
}

export default function TermsModalLayout({
  type,
  isOpen,
  setIsOpen,
}: TermsModalLayoutProps) {
  useEffect(() => {
    if (isOpen) {
      enableScrollLock();
    } else {
      disableScrollLock();
    }
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <>
          <Container className='Modal'>
            <CloseButton onClick={() => setIsOpen(false)}>
              <Icon color='content_light_1' iconName='Close' size={40} />
            </CloseButton>
            <ContentWrapper>
              {type === 'privacyPolicy' && <PrivacyPolicy />}
              {type === 'termsOfService' && (
                <>
                  <TermsOfService />
                  <PersonalInfo />
                </>
              )}
            </ContentWrapper>
          </Container>
        </>
      )}
    </>
  );
}

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.modal};
    top: 50%;
    left: 50%;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%) translate(-0.5px, -0.5px);
    border-radius: 16px;
    background: ${theme.backgroundColor.base};
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const CloseButton = styled.button`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
`;
